import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: {},
  errors: null,
  isLoading: false,
  total: 0,
  offset: 0,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: null,
        data: action.payload.data || [],
        total: action.payload.total || 0,
        offset: action.payload.offset || 0,
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetReservationItemReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetReservationItemReducer
export {ActionTypes, InitialState, Reducer}
